var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStars(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "24px",
    viewBox: "0 0 37 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App-Movil",
    stroke: "none",
    strokeWidth: 1,
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Proposals-empty",
    transform: "translate(-243.000000, -744.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab-Bar",
    transform: "translate(0.000000, 728.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tab-1",
    transform: "translate(23.666667, 6.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stars",
    transform: "translate(219.195106, 10.639126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4631608,17.3912639 L22.3173549,13.6942764 L24.6141201,10.7883218 L21.0503156,9.78585575 L18.9808696,6.7010235 L16.9114236,9.78585575 L13.3476191,10.7883218 L15.6443842,13.6942764 L15.4983719,17.3964981 L18.9948249,16.1116652 L22.4631608,17.3912639 Z",
    id: "Path",
    stroke: "currentColor",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4568787,15.6811921 L28.6376414,14.1195646 L31.925455,15.3338501 L31.755622,11.0187587 L34.4288972,7.63248364 L30.2780085,6.46378007 L27.865163,2.86365809 L25.8669837,5.84551436 L23.9612547,5.23813305 L24.469477,5.09502178 L27.8653423,0.0275406469 L31.2612076,5.09502178 L37.1382269,6.74994242 L33.3536094,11.5435056 L33.5937211,17.6381789 L27.8767762,15.5267284 L27.4568787,15.6811921 Z",
    id: "Combined-Shape",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.78869381,15.6811921 L4.96945648,14.1195646 L8.25727002,15.3338501 L8.08743709,11.0187587 L10.7607122,7.63248364 L6.60982353,6.46378007 L4.19697804,2.86365809 L2.1987988,5.84551436 L0.293069713,5.23813305 L0.801292106,5.09502178 L4.19715737,0.0275406469 L7.59302263,5.09502178 L13.470042,6.74994242 L9.68542445,11.5435056 L9.92553614,17.6381789 L4.20859126,15.5267284 L3.78869381,15.6811921 Z",
    id: "Combined-Shape",
    opacity: 0.5,
    transform: "translate(6.881608, 8.832860) scale(-1, 1) translate(-6.881608, -8.832860) "
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStars);
export default __webpack_public_path__ + "static/media/icon-stars.164f5cee.svg";
export { ForwardRef as ReactComponent };